import {notification} from 'antd'
import {stakeholderService} from '../services'
import i18nextConfig from '../../../config/i18next'

const changePasswordUserPortal = (dni, password, newPassword, countryCode) => {
    return new Promise((resolve, reject) => {
        if (password === '' || newPassword === '' || countryCode === '') {
            notification.error({message: i18nextConfig.t('messages.aml.missingRequiredField')})
            return false
        } else {
            stakeholderService.changePwdUserPortal(dni, password, newPassword, countryCode)
                .then(response => {
                    resolve({success: true, data: response})
                })
                .catch(data => {
                    if (data.response.status === 500) {
                        reject({success: false, data: data.response.data})
                    } else {
                        resolve({success: false, data: data.response})
                    }
                })
        }
    })
}

export default changePasswordUserPortal;